import React, { useEffect, useState } from 'react';
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Typography } from '@mui/material';
import { fetchGemaraOrder, orderGemara } from '../mishtameretPortalApi';

/**
 * הזמנת כרך גמרא בסיום מבחן — מוצג רק כשיש כרך פתוח במסגרת המבחן (כמו בטלפון: אחרי הציון).
 * טופס סימון «אני רוצה להזמין כרך גמרא X» + אישור.
 */
const GemaraOrderCard = ({ attemptId, theme }) => {
  const [offer, setOffer] = useState(null);
  const [wanted, setWanted] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetchGemaraOrder(attemptId)
      .then((data) => { if (!cancelled) setOffer(data); })
      .catch(() => { /* בלי כרך פתוח / שגיאה — פשוט לא מציגים */ });
    return () => { cancelled = true; };
  }, [attemptId]);

  if (!offer?.available) return null;

  const handleOrder = async () => {
    setSaving(true);
    setError('');
    try {
      setOffer(await orderGemara(attemptId));
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בהזמנה, נסו שוב');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: theme.surface,
        borderRadius: 2.5,
        border: `1px solid ${offer.ordered ? theme.success : theme.accent}`,
        px: 2,
        py: 1.75,
        mb: 2,
        boxShadow: theme.shadow,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ flex: '1 1 220px', minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, color: theme.text }}>
          הזמנת כרך גמרא
        </Typography>
        {offer.ordered ? (
          <Typography sx={{ color: theme.success, fontSize: '0.85rem', mt: 0.25 }}>
            ההזמנה התקבלה, שליח הקודש בעירך יצור איתך קשר למסירת הגמרא
          </Typography>
        ) : (
          <FormControlLabel
            sx={{ mt: 0.5, mr: 0, color: theme.text }}
            control={(
              <Checkbox
                checked={wanted}
                onChange={(e) => setWanted(e.target.checked)}
                disabled={saving}
                sx={{ color: theme.accent, '&.Mui-checked': { color: theme.accent } }}
              />
            )}
            label={`אני רוצה להזמין כרך גמרא ${offer.campaign?.title || ''}`.trim()}
          />
        )}
        {error ? (
          <Typography sx={{ color: theme.danger, fontSize: '0.85rem', mt: 0.5 }}>{error}</Typography>
        ) : null}
      </Box>
      {!offer.ordered ? (
        <Button
          onClick={handleOrder}
          disabled={saving || !wanted}
          sx={{
            minHeight: 44,
            px: 3,
            borderRadius: 999,
            bgcolor: theme.accent,
            color: theme.accentContrast,
            fontWeight: 700,
            '&:hover': { bgcolor: theme.accentSoft },
            '&.Mui-disabled': { bgcolor: theme.borderSoft, color: theme.textMuted },
          }}
        >
          {saving ? <CircularProgress size={22} /> : 'אישור ההזמנה'}
        </Button>
      ) : null}
    </Box>
  );
};

export default GemaraOrderCard;
